import { Navigate, useParams } from 'react-router-dom';
import { DEFAULT_LANG } from './LangLayout';

// Backward-compat: bounces the old unprefixed public URLs (bookmarks, links
// out in the wild, direct navigation before this scheme existed) to the
// canonical language-prefixed one under the default language. `suffix` is a
// static tail (e.g. "/contact"); `paramNames` lets dynamic segments (help
// category/post slugs) be carried over into the redirect target.
const LangRedirect = ({ suffix = '', paramNames = [] }) => {
  const params = useParams();
  const tail = paramNames.map((name) => `/${params[name]}`).join('');
  return <Navigate to={`/${DEFAULT_LANG}${suffix}${tail}`} replace />;
};

export default LangRedirect;
